import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { requireAuth } from '@/lib/auth'
import { RouteError } from '@/components/route-error'
import { RoutePending } from '@/components/route-pending'
import { DeliveriesPage } from '@/features/pos/delivery/deliveries-page'
import { reportRangeSearchSchema } from '@/features/reports/components/report-range-search'

const searchSchema = z
  .object({
    // Run whose manifest is open in the side panel ('' = closed).
    manifestRun: z.string().catch(''),
    // 'board' = the live worklist, 'history' = the delivery performance report.
    tab: z.enum(['board', 'history']).catch('board'),
  })
  // The History tab drives the same range filter every report page uses, so it
  // carries the same search params — a range stays shareable via the URL.
  .merge(reportRangeSearchSchema)

export const Route = createFileRoute('/_dashboard/deliveries')({
  beforeLoad: requireAuth(),
  validateSearch: searchSchema,
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: DeliveriesPage,
})
